import { render } from "./FilesDownload.vue?vue&type=template&id=325179da"
import script from "./FilesDownload.vue?vue&type=script&lang=js"
export * from "./FilesDownload.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/extranet-sinistre/production/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__